import { useCallback, useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { isValidationException } from "../core/api/ValidationExceptionResponse";

/**
 * Send an error to user tracking. Supports either { message: string} or api validation exception
 * @param {string} eventName
 * @returns {(error: any) => void}
 */
function useUserTrackingErrorEvent(eventName: string = "error") {
  const { analytics } = useContext(GlobalContext);

  return useCallback(
    (error: any) => {
      console.log(error);
      if (isValidationException(error)) {
        analytics.trackEvent(
          eventName,
          error.response.body.validationErrors.reduce((a, c) => ({ ...a, [c.property]: c.error }), {})
        );
      } else {
        analytics.trackEvent(eventName, {
          message: error.message,
        });
      }
    },
    [eventName]
  );
}

export default useUserTrackingErrorEvent;
